import React from 'react'
import './Slider.css'
import leftArrow from "./icons/left-arrow.svg";
import rightArrow from "./icons/right-arrow.svg";

const BtnSlider = ({moveSlide, direction}) => {
    // console.log(direction)
  return (
    <button onClick={moveSlide} className={ direction === 'next' ? 'btn-slide next slider-button w-[30px] h-[30px] right-[-31px] md:right-[-45px] lg:right-[-48px] md:w-[40px] md:h-[40px]' : 'btn-slide prev slider-button w-[30px] h-[30px] left-[-31px] md:left-[-45px] lg:left-[-48px] md:w-[40px] md:h-[40px]'}>
        <img
            src={direction === 'next' ? rightArrow : leftArrow}
            className='slider-button-icon w-[17px] h-[17px] md:w-[23px] md:h-[23px]'
            alt='arrow-images'
        />
    </button>
  )
}

export default BtnSlider